import script from "./AddItemDetails.vue?vue&type=script&setup=true&lang=js"
export * from "./AddItemDetails.vue?vue&type=script&setup=true&lang=js"

import "./AddItemDetails.vue?vue&type=style&index=0&id=e24821aa&scoped=true&lang=css"

import exportComponent from "/Users/amsrafid/Projects/www/miaccounts-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e24821aa"]])

export default __exports__